"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback } from "react";
import { useAIChatMessageContext } from "@/components/ai-chat/contexts";
import { renderTextWithCitations } from "@/lib/format-ai-text";
interface PatientCitationContentProps {
  onCitationClick: (tab: string, itemId?: string) => void;
  className?: string;
}

/**
 * Domain-specific message content component for Patient QA chat.
 * Reads message content from AIChatMessageContext and renders it
 * with clickable citation links that navigate to patient tabs.
 */
export function PatientCitationContent(t0) {
  const $ = _c(10);
  const {
    onCitationClick,
    className
  } = t0;
  const {
    message
  } = useAIChatMessageContext();
  const content = typeof message.content === "string" ? message.content : String(message.content || "");
  let t1;
  if ($[0] !== onCitationClick) {
    t1 = text => renderTextWithCitations(text, onCitationClick);
    $[0] = onCitationClick;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const rendered = t1;
  if (!content) {
    return null;
  }
  let t2;
  if ($[2] !== content || $[3] !== rendered) {
    t2 = rendered(content);
    $[2] = content;
    $[3] = rendered;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <div className="text-body leading-relaxed text-foreground">{t2}</div>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== className || $[8] !== t3) {
    t4 = <div className={className}>{t3}</div>;
    $[7] = className;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}